import React from 'react'
import { Route, Routes } from 'react-router-dom'

import SalepageCreatePage from './Features/SalepageCreate'
import SalepageDetailPage from './Features/SalepageDetail'
import SalepageListPage from './Features/SalepageList'
import SalepagePreviewPage from './Features/SalepagePreview'

const SalepagePage = () => {
  return (
    <Routes>
      <Route path="/" element={<SalepageListPage />} />
      <Route path="/create" element={<SalepageCreatePage />} />
      <Route path="/preview/:id" element={<SalepagePreviewPage />} />
      <Route path="/:id" element={<SalepageDetailPage />} />
    </Routes>
  )
}

export default SalepagePage
